import React, { createContext, useContext } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

const LIBRARIES = ['places', 'drawing', 'geometry'];
const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const GoogleMapsContext = createContext({ isLoaded: false });

export const useGoogleMaps = () => useContext(GoogleMapsContext);

export function GoogleMapsProvider({ children }) {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: API_KEY || '',
    libraries: LIBRARIES,
  });

  if (loadError) {
    console.error('Google Maps load error:', loadError);
  }

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
}
